import { SET_LOCALE_PREFS } from "./types";
export const setLocalePrefs = (data: any) => ({
	type: SET_LOCALE_PREFS,
	payload: data,
});
